import React from 'react';
import SafetyGlassess from './../components/SafetyGlasses';
import FullFrame from './../components/FullFrame';
import FrameLess from './../components/FrameLess';
import HalfFrame from './../components/HalfFrame';
import Sunglassess from './../components/Sunglassess';
import KidsFrame from './../components/KidsFrame';
import KidsSungless from './../components/KidsSungless';
import DMF from './../components/DMF';
export default function Pcontainer() {
  return (
    <>
      
      <FullFrame />
      <DMF />
      <FrameLess />
      <HalfFrame />
      <Sunglassess />
      <SafetyGlassess />
      <KidsFrame />
      <KidsSungless />
    </>
  );
}
